import { modaal } from './libs/modaal.min.js';
import { content } from './modules/content';
modaal();
content();